<div #zoomDiv class="jk-row-border">
  <h4 class="text-center text-blue-700">遠端喇叭(mqttSpeaker)</h4>
  <div class="flex">
    <app-jkcheckbox label="使用azure語音" [(value)]="isAzureSpeech">
    </app-jkcheckbox>
    <app-jkcheckbox label="靜音" [(value)]="isSilence">
    </app-jkcheckbox>
  </div>
  <div class="flex">
    <button class="btn" [class.btn-secondary]="true" (click)="doStopSpeech()">
      閉嘴
    </button>
    <app-jknumberedit label="pub秒數" [(value)]="pubSecond"></app-jknumberedit>
  </div>
  <app-jktextarea [(value)]="logMessage" [maxlength]="10" [minHeight]="300">
  </app-jktextarea>
</div>
